import React, { useState } from 'react'
import { Helmet } from 'react-helmet-async'
import { Typography, Button, Grid, Autocomplete, TextField } from '@mui/material'
import { Navbar } from '../../component/shared/Navbar'
import AddIcon from '@mui/icons-material/Add'
import Table from './Table'
import { PageContainer } from '../../component/styled/PageContainer'
import { useExportSalesCommission } from '../../api/sales-commission'
import { ExportButton } from '../../component/shared/component/ExportButton'
import Breadcrumb from '../../component/shared/Breadcrumb'
import { getRecentMonths } from '../../utils/date'

export const Commission = () => {
  const monthOptions = getRecentMonths(12)
  const [open, setOpen] = useState(false)
  const [monthYear, setMonthYear] = useState(monthOptions[0].value)
  const { mutateAsync: getExport } = useExportSalesCommission()

  return (
    <>
      <Helmet titleTemplate='%s | Staff Portal' defaultTitle='Staff Portal'>
        <title>Sales Commission</title>
      </Helmet>
      <Navbar />
      <PageContainer>
        <Grid container spacing={2} paddingTop={5}>
          <Grid item xs={12}>
            <Breadcrumb items={[{ label: 'Commission' }]} />
            <Typography variant='h1'>Commission</Typography>
          </Grid>
          <Grid item xs={12} display='flex' gap={2}>
            <Autocomplete
              options={monthOptions}
              value={monthOptions.find((option) => option.value === monthYear)}
              onChange={(_, { value }) => value && setMonthYear(value)}
              getOptionLabel={(option) => option.label}
              renderInput={(params) => <TextField {...params} variant='outlined' fullWidth />}
              fullWidth
              disableClearable={true}
            />
            <Button
              variant='contained'
              color='primary'
              onClick={() => setOpen(true)}
              startIcon={<AddIcon style={{ color: '#FFFFFF' }} />}
              size='large'
            >
              IMPORT
            </Button>
          </Grid>
          <Grid item xs={12} display={'flex'} justifyContent={'flex-end'}>
            <ExportButton
              exportFn={() => getExport({ monthYear })}
              filename={`Sales_Commission_${monthYear}.xlsx`}
            />
          </Grid>
          <Grid item xs={12}>
            <Table monthYear={monthYear} open={open} setOpen={setOpen} />
          </Grid>
        </Grid>
      </PageContainer>
    </>
  )
}
